// Converts numeric degrees to radians
function toRad(Value) {
  return (Value * Math.PI) / 180;
}

function calcCrow(lat1, lon1, lat2, lon2) {
  const R = 6371; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const lat1Rad = toRad(lat1);
  const lat2Rad = toRad(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) *
      Math.sin(dLon / 2) *
      Math.cos(lat1Rad) *
      Math.cos(lat2Rad);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return Math.round(d);
}

export const getDistanceFromPosition = (item, position) => {
  return calcCrow(
    item.position.lat,
    item.position.lng,
    position.lat,
    position.lng
  );
};

// export const sortDistanceFromPosition = (a, b, position, order = 'ASC') => {
//   switch (order) {
//     case 'ASC':
//       return (
//         getDistanceFromPosition(a, position) -
//         getDistanceFromPosition(b, position)
//       );
//     case 'DES':
//     default:
//       return (
//         getDistanceFromPosition(b, position) -
//         getDistanceFromPosition(a, position)
//       );
//   }
// };
